import React from 'react';
import HeroSection from '../../components/HeroSection/HeroSection';
import MissionSection from '../../components/MissionSection/MissionSection';

const Home = () => {
  return (
    <div>
      <HeroSection />
      <MissionSection />
    </div>
  );
};

export default Home;